import firebase from '../firebase'
import {
  GLP_LOGGED_PROFILE,
  LOGIN_SUCCESS,
  LOG_USER_PROFILE_DIALOG,
  BASE_API_URL,
  USER_ANALYTICS
} from './types'
import { _toArray } from './commonActions'
import axios from 'axios'
import { loggedInCompanyActions } from './loggedInCompanyActions'

export const loggedInProfileActions = (uid) => {
  return async (dispatch, getState) => {
    // Step 1: Validate the passed UID against the authenticated user's UID
    const currentUser = firebase.auth.currentUser;
    if (!currentUser || uid !== currentUser.uid) {
      
      dispatch({
        type: LOG_USER_PROFILE_DIALOG,
        userDetails: []
      });
      return;
    }

    try {
      // Step 2: Use 'once' to fetch the user data as a one-time read
      const userRef = firebase.database.ref('user/' + uid);
      const snapshot = await userRef.once('value');

      if (snapshot.exists()) {
        const userData = snapshot.val();
        

        let formattedData = [];
        formattedData[0] = { ...userData, id: uid, uid: uid };

        // Step 3: Validate user data before storing it in local storage
        // If userData doesn't have a uid field, add it from the authenticated user
        if (!userData.uid && userData) {
          
          userData.uid = currentUser.uid;
        }
        
        // If user data is missing critical fields, add them from the authenticated user
        if (userData && (!userData.email || !userData.firstName)) {
          
          if (!userData.email && currentUser.email) {
            userData.email = currentUser.email;
          }
          if (!userData.firstName && currentUser.displayName) {
            const nameParts = currentUser.displayName.split(' ');
            userData.firstName = nameParts[0] || '';
            userData.lastName = nameParts.slice(1).join(' ') || '';
          }
          if (!userData.displayName && currentUser.displayName) {
            userData.displayName = currentUser.displayName;
          }
        }
        
        if (userData.uid === currentUser.uid) {
          localStorage.removeItem(GLP_LOGGED_PROFILE);
          localStorage.setItem(GLP_LOGGED_PROFILE, JSON.stringify(userData));

          // Step 4: Call loggedInCompanyActions with proper checks
          if (userData.companyID) {
            loggedInCompanyActions(userData.companyID);
          } else {
            
          }

          

          // Dispatch success with user data
          dispatch({
            type: LOG_USER_PROFILE_DIALOG,
            userDetails: formattedData
          });
        } else {
          
          dispatch({
            type: LOG_USER_PROFILE_DIALOG,
            userDetails: []
          });
        }
      } else {
        
        dispatch({
          type: LOG_USER_PROFILE_DIALOG,
          userDetails: []
        });
      }
    } catch (error) {
      
      dispatch({
        type: LOG_USER_PROFILE_DIALOG,
        userDetails: []
      });
    }
  };
};

export const loggedInProfileActions_25Jan_2025 = (uid) => {
  return (dispatch, getState) => {
    if (uid) {
      firebase.database.ref('user/' + uid).on('value', function (res) {
        if (res.val()) {
          let formattedData = []
          formattedData[0] = res.val()
          formattedData[0].id = uid
          formattedData[0].uid = uid
          // formattedData[0].userID = res.val().userID;
          // formattedData[0].companyID = res.val().companyID;
          localStorage.removeItem(GLP_LOGGED_PROFILE)
          localStorage.setItem(GLP_LOGGED_PROFILE, JSON.stringify(res.val()))
          loggedInCompanyActions(res.val().companyID)

          dispatch({
            type: LOG_USER_PROFILE_DIALOG,
            userDetails: formattedData
          })
        } else {
          dispatch({
            type: LOG_USER_PROFILE_DIALOG,
            userDetails: []
          })
        }
      })
      // axios
      //   .get(`${BASE_API_URL}/users`, {
      //     params: {
      //       tblcol: "uid",
      //       tblval: uid
      //     }
      //   })
      //   .then(res => {
      //     var formattedData = [];
      //     formattedData[0] = res.data.data;
      //     formattedData[0].id = uid;
      //     formattedData[0].uid = uid;
      //     localStorage.setItem(
      //       GLP_LOGGED_PROFILE,
      //       JSON.stringify(res.data.data)
      //     );
      //     loggedInCompanyActions(res.data.data.companyID);

      //     dispatch({
      //       type: LOG_USER_PROFILE_DIALOG,
      //       userDetails: formattedData
      //     });
      //     // dispatch({ type: USER_ANALYTICS });
      //   })
      //   .catch(err => {
      //   });
    } else {
      dispatch({
        type: LOG_USER_PROFILE_DIALOG,
        userDetails: []
      })
    }
  }
}

export const loggedInProfileActions2 = (uid) => {
  return (dispatch, getState) => {
    if (uid) {
      firebase.database.ref('users/' + uid).on('value', function (res) {
        if (res.val()) {
          let formattedData = []
          formattedData[0] = res.val()
          formattedData[0].id = uid
          formattedData[0].uid = uid
          // formattedData[0].userID = res.val().userID;
          // formattedData[0].companyID = res.val().companyID;
          localStorage.removeItem(GLP_LOGGED_PROFILE)
          localStorage.setItem(GLP_LOGGED_PROFILE, JSON.stringify(res.val()))
          loggedInCompanyActions(res.val().companyID)

          dispatch({
            type: LOG_USER_PROFILE_DIALOG,
            userDetails: formattedData
          })
        } else {
          dispatch({
            type: LOG_USER_PROFILE_DIALOG,
            userDetails: []
          })
        }
      })
  
    } else {
      dispatch({
        type: LOG_USER_PROFILE_DIALOG,
        userDetails: []
      })
    }
  }
}

export const loggedInSuccess = (userobj) => {
  return (dispatch, getState) => {
    dispatch({ type: LOGIN_SUCCESS, auth: userobj })
  }
}
